export interface IpDataInterface {
    ip: string
}
export class IpData implements IpDataInterface {
    ip: string;
    
    constructor(data: IpDataInterface) {
        this.ip = data.ip;
    }
}